// Global headers singleton for API requests
export const globalHeaders = new Headers();

export const getGlobalHeadersAsObject = (): Record<string, string> => {
	const returnHeaders: Record<string, string> = {};
	for (const pair of globalHeaders.entries()) {
		returnHeaders[pair[0]] = pair[1];
	}
	return returnHeaders;
};

export const registerGlobalHeader = (header: string, value: string): void => {
	if (value) {
		globalHeaders.set(header, value);
	} else {
		globalHeaders.delete(header);
	}
};

// One-shot: when the React app is loaded inside the Artemis WebView2 host,
// MainWindow.OnLoaded injects window.__ARTEMIS_HOST_VERSION__ via
// AddScriptToExecuteOnDocumentCreatedAsync (runs before any page script).
// Forwarding it as a header lets the backend attribute every authenticated
// request from the host (including TODO/Celery-queue page hits) to the host
// installation. Same-origin only — never reaches LinkedIn.
const artemisHostVersion = (window as unknown as { __ARTEMIS_HOST_VERSION__?: unknown })
	.__ARTEMIS_HOST_VERSION__;
if (artemisHostVersion) {
	registerGlobalHeader("X-Artemis-Host-Version", String(artemisHostVersion));
}
